import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { validAttributeNumberValue } from '@iotv/iotv-v3-types';
import Stack from '@mui/material/Stack';
/** if pass is true, validation is OK when regex returns a match, if false, validation FAILS when regex return a match. consumers should Default to true when non extant */
export const validByRegex = (newValue, validationRx, pass = true) => {
    let isValid = false;
    if (validationRx === undefined) {
        isValid = true;
    }
    else {
        const regexRes = validationRx.test(newValue ?? '');
        isValid = pass !== false ? regexRes : !regexRes;
    }
    return isValid;
};
export const isInLimits = (value, limits) => !validAttributeNumberValue(value, limits).error;
export const ValidationErrorsList = ({ validationMap }) => {
    const entries = Object.entries(validationMap).filter(([k, v]) => v);
    return entries.length > 0 ? (_jsx(Stack, { children: entries.map(([k, v]) => (_jsx("div", { children: v?.content }, k))) })) : (_jsx(_Fragment, {}));
};
